<form [formGroup]="form">
  <div class="row">
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label">État du poste@if (this.form.get('etatPoste')?.hasValidator(Validators.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez l'état du poste.</div>
        <mat-form-field class="w-100">
          <mat-select formControlName="etatPoste">
            <mat-option value="Ouvert">Ouvert</mat-option>
            <mat-option value="Ferme">Fermé</mat-option>
          </mat-select>
          @if (form.get('etatPoste')?.hasError('required') && form.get('etatPoste')?.touched) {
            <mat-error>
              L'état du poste est requis.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label">Occupation du poste@if (this.form.get('occupationPoste')?.hasValidator(Validators.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez l'occupation du poste.</div>
        <mat-form-field class="w-100">
          <mat-select formControlName="occupationPoste">
            <mat-option value="Pourvu">Pourvu</mat-option>
            <mat-option value="Vacant">Vacant</mat-option>
          </mat-select>
          @if (form.get('occupationPoste')?.hasError('required') && form.get('occupationPoste')?.touched) {
            <mat-error>
              L'occupation du poste est requise.
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label">Catégorie du poste@if (this.form.get('categoriePoste')?.hasValidator(Validators.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez la catégorie du poste.</div>
        <mat-form-field class="w-100">
          <mat-select formControlName="categoriePoste" aria-label="Catégorie du poste" [compareWith]="idComparer">
            @for (categorie of categoriePosteList; track categorie) {
              <mat-option [value]="categorie">
                {{ categorie.code }}
              </mat-option>
            }
          </mat-select>
          <!-- categoriePoste is never required per business rules -->
        </mat-form-field>
      </div>
    </div>
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label">Détenteur du poste@if (this.form.get('detenteurPoste')?.hasValidator(Validators.required)) {
          *
        }</label>
        <div class="form-text mb-1">
          @if (!form.get('detenteurPoste')?.disabled) {
            <span>Saisissez le nom du détenteur du poste.</span>
          }
          @if (form.get('detenteurPoste')?.disabled) {
            <span>Détenteur du poste (chargé automatiquement).</span>
          }
        </div>
        <!-- ✅ Single input field with conditional behavior managed by FormControl -->
        <mat-form-field class="w-100">
          <input type="text"
            matInput
            aria-label="Détenteur du poste"
            formControlName="detenteurPoste" />
          </mat-form-field>
        </div>
      </div>

      <div class="col-6 mb-3">
        <div class="row">
          <label class="label col-12 col-form-label">Date de recrutement souhaitée@if (this.form.get('dateRecrutement')?.hasValidator(Validators.required)) {
            *
          }</label>
          <div class="form-text mb-1">Sélectionnez la date de recrutement.</div>
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="recrutementDatePicker" [min]="minDateRecrutement"
              formControlName="dateRecrutement" (dateChange)="onChangeRecrutementdate()" />
              <mat-datepicker-toggle matSuffix [for]="recrutementDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #recrutementDatePicker></mat-datepicker>
              @if (form.get('dateRecrutement')?.hasError('required') && form.get('dateRecrutement')?.touched) {
                <mat-error>
                  La date de recrutement est requise.
                </mat-error>
              }
              @if (form.get('dateRecrutement')?.hasError('dateR_Invalide')) {
                <mat-error>
                  La date de recrutement doit être antérieure à la date de départ.
                </mat-error>
              }
              @if (form.get('dateRecrutement')?.hasError('matDatepickerMin')) {
                <mat-error>
                  La date de recrutement doit être supérieure ou égale à la date du jour.
                </mat-error>
              }
              <!-- <mat-error>
              {{ form.get('dateDepart')?.errors | json }}
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>

      <div class="col-6 mb-3">
        <div class="row">
          <label class="label col-12 col-form-label">Date de départ définitif@if (this.form.get('dateDepart')?.hasValidator(Validators.required)) {
            *
          }</label>
          <div class="form-text mb-1">Sélectionnez ou saisissez une date au format DD/MM/YYYY.</div>
          <mat-form-field class="w-100">
            <input matInput [matDatepicker]="departDatePicker" [min]="minDateDepart" formControlName="dateDepart"
              (dateChange)="onChangeDepartdate()" />
              <mat-datepicker-toggle matSuffix [for]="departDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #departDatePicker (opened)="datePickerOpened('dateDepart')"></mat-datepicker>

              @if (form.get('dateDepart')?.hasError('dateD_Invalide')) {
                <mat-error>
                  La date de départ doit être postérieure à la date de recrutement.
                </mat-error>
              }
              @if (form.get('dateDepart')?.hasError('matDatepickerMin')) {
                <mat-error>
                  La date de départ doit être supérieure ou égale à la date du jour.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="col-6 mb-3">
          <div class="row">
            <label class="label col-12 col-form-label">Type de recrutement souhaité@if (this.form.validator) {
              *
            }</label>
            <div class="form-text mb-1">Choisissez le type de recrutement.</div>
            <div class="checkbox-group">
              <mat-checkbox formControlName="interne" color="primary">Interne</mat-checkbox>
              <mat-checkbox formControlName="externe" color="primary">Externe</mat-checkbox>
            </div>
            @if (form.hasError('atLeastOneRequired') && form.touched) {
              <mat-error> Vous devez sélectionner au moins une
              option. </mat-error>
            }
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="row">
            <label class="label col-12 col-form-label">Poste budgété en 2025@if (this.form.get('posteBudgete')?.hasValidator(Validators.required)) {
              *
            }</label>
            <div class="form-text mb-1">Sélectionnez (oui, non).</div>
            <mat-form-field class="w-100">
              <mat-select formControlName="posteBudgete">
                <mat-option [value]="true">Oui</mat-option>
                <mat-option [value]="false">Non</mat-option>
              </mat-select>
              @if (form.get('posteBudgete')?.hasError('required') && form.get('posteBudgete')?.touched) {
                <mat-error>
                  Le poste budgété est requis.
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
